import React from 'react';
import gniLogo from '../assets/gni-logo.png'; // Import the logo
import './Logo.css'; // Optional: Custom CSS for the logo

function Logo() {
  return (
    <div className="logo-container">
      <a href="/">
        <img src={gniLogo} alt="GNI Logo" className="logo" />
      </a>
    </div>
  );
}

export default Logo;
